import { Position, Severity, ToastData } from './toastMessageTypes';

export const POSITIONS: Position[] = [
  'left',
  'center',
  'right',
  'top',
  'topRight',
  'topLeft',
  'bottomRight',
];

export const SEVERITY_STYLES: Record<
  Severity,
  {
    border: string;
    bgOutlined: string;
    bgFilled: string;
    textOutlined: string;
    textFilled: string;
    icon: string;
    outlinedOpacity?: string;
  }
> = {
  error: {
    border: 'border-error-dark',
    bgOutlined: 'bg-surface-content',
    bgFilled: 'bg-error-dark',
    textOutlined: 'text-error-light',
    textFilled: 'text-text-primary',
    icon: 'text-text-primary',
  },
  info: {
    border: 'border-secondary-main',
    bgOutlined: 'bg-secondary-background',
    bgFilled: 'bg-secondary-main',
    textOutlined: 'text-secondary-light',
    textFilled: 'text-text-primary',
    icon: 'text-secondary-light',
    outlinedOpacity: '0.8',
  },
  warning: {
    border: 'border-warning-main',
    bgOutlined: 'bg-surface-content',
    bgFilled: 'bg-warning-main',
    textOutlined: 'text-warning-light',
    textFilled: 'text-text-primary',
    icon: 'text-warning-light',
  },
  success: {
    border: 'border-success-main',
    bgOutlined: 'bg-surface-content',
    bgFilled: 'bg-success-main',
    textOutlined: 'text-success-light',
    textFilled: 'text-text-primary',
    icon: 'text-success-light',
  },
};

export const notificationPlacement = (pos: Position) => {
  return `toastContainer position-${pos}`;
};

export const entranceAnimations: Record<Position, string> = {
  topRight: 'entranceRight',
  topLeft: 'entranceLeft',
  right: 'entranceRight',
  left: 'entranceLeft',
  top: 'entranceDown',
  center: 'entranceUp',
  bottomRight: 'entranceRight',
};

export const exitAnimations: Record<Position, string> = {
  topRight: 'exitRight',
  topLeft: 'exitLeft',
  right: 'exitRight',
  left: 'exitLeft',
  top: 'exitUp',
  center: 'exitDown',
  bottomRight: 'exitRight',
};

export const getIconName = (severity: ToastData['severity']) => {
  switch (severity) {
    case 'error':
      return 'error-outline';
    case 'warning':
      return 'warning-outlined';
    case 'success':
      return 'check-circle-outline-outlined';
    case 'info':
    default:
      return 'info-outlined';
  }
};
